module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/feature03-9f209ce25ac2933115bc33c527ffe0e2.svg";